/**
 * Custom date formats, keyed by language.
 *
 * @namespace tmrDateFormats
 * @type {ngConstant}
 */
export const constant = [
  'tmrDateFormats',
  {
    en: {
      mediumMilliseconds: 'M/d/yy h:mm:ss:sss a',
    },
    it: {
      mediumMilliseconds: 'dd/MM/yy HH:mm:ss:sss',
    },
  },
]

/**
 * Applies custom date formats to dynamic $locale.
 *
 * @type {ngRun}
 */
let tmrDateFormatsRun = /*@ngInject*/ ($rootScope, tmrDateFormats) => {
  $rootScope.$on('$localeChangeSuccess', (event, localeId, $locale) => {
    for (let name in tmrDateFormats[localeId]) {
      $locale.DATETIME_FORMATS[name] = tmrDateFormats[localeId][name]
    }
  })
}

export { tmrDateFormatsRun as run }
